import {
  AgeBand,
  AgeGroup,
  BodySide,
  FamilyIncomeBand,
  FinancingType,
  GlucoseTargets,
  GlucoseThresholds,
  InjectionPoint,
  ParentEducation,
  InjectionRegion,
  RegionGrid,
  RegionPlacement
} from '../types/domain';

export type { BodySide };

export type GlucoseZone = 'low' | 'normal' | 'warning' | 'high';
export type MeasurementContextGroup = 'pre' | 'post' | 'other';

export interface InjectionSite {
  id: number;
  label: string;
  side: BodySide;
  x: number;
  y: number;
}

export const kidsSites: InjectionSite[] = [
  { id: 1, label: 'Lengan Atas Kanan: 1/3 Atas sisi luar', side: 'front', x: 22, y: 30 },
  { id: 2, label: 'Lengan Atas Kiri: 1/3 Atas sisi luar', side: 'front', x: 78, y: 30 },
  { id: 3, label: 'Perut Kanan Atas', side: 'front', x: 44, y: 45 },
  { id: 4, label: 'Perut Kiri Atas', side: 'front', x: 56, y: 45 },
  { id: 5, label: 'Paha Kanan: 1/3 Atas Sisi Luar', side: 'front', x: 40, y: 65 },
  { id: 6, label: 'Paha Kiri: 1/3 Atas Sisi Luar', side: 'front', x: 60, y: 65 },
  { id: 7, label: 'Lengan Atas Kanan: 1/3 Tengah sisi luar', side: 'front', x: 22, y: 40 },
  { id: 8, label: 'Lengan Atas Kiri: 1/3 Tengah sisi luar', side: 'front', x: 78, y: 40 },
  { id: 9, label: 'Perut Kanan Bawah', side: 'front', x: 44, y: 55 },
  { id: 10, label: 'Perut Kiri Bawah', side: 'front', x: 56, y: 55 },
  { id: 11, label: 'Paha Kiri: 1/3 Tengah Sisi Luar', side: 'front', x: 60, y: 75 },
  { id: 12, label: 'Paha Kanan: 1/3 Tengah Sisi Luar', side: 'front', x: 40, y: 75 },
  { id: 13, label: 'Lengan Atas Kanan: 1/3 Atas sisi belakang', side: 'back', x: 22, y: 30 },
  { id: 14, label: 'Lengan Atas Kiri: 1/3 Atas sisi belakang', side: 'back', x: 78, y: 30 },
  { id: 15, label: 'Bokong Kanan: Bagian sisi luar atas', side: 'back', x: 44, y: 65 },
  { id: 16, label: 'Bokong Kiri: Bagian sisi luar atas', side: 'back', x: 56, y: 65 },
  { id: 17, label: 'Lengan Atas Kanan: 1/3 Tengah sisi belakang', side: 'back', x: 22, y: 40 },
  { id: 18, label: 'Lengan Atas Kiri: 1/3 Tengah sisi belakang', side: 'back', x: 78, y: 40 }
];

export const teenSites: InjectionSite[] = [
  { id: 1, label: 'Lengan Atas Kanan: 1/3 Atas sisi luar', side: 'front', x: 22, y: 30 },
  { id: 2, label: 'Lengan Atas Kiri: 1/3 Atas sisi luar', side: 'front', x: 78, y: 30 },
  { id: 3, label: 'Perut Kanan Atas', side: 'front', x: 44, y: 45 },
  { id: 4, label: 'Perut Kiri Atas', side: 'front', x: 56, y: 45 },
  { id: 5, label: 'Paha Kanan: 1/3 Atas Sisi Luar', side: 'front', x: 40, y: 65 },
  { id: 6, label: 'Paha Kiri: 1/3 Atas Sisi Luar', side: 'front', x: 60, y: 65 },
  { id: 7, label: 'Lengan Atas Kanan: 1/3 Tengah sisi luar', side: 'front', x: 22, y: 40 },
  { id: 8, label: 'Lengan Atas Kiri: 1/3 Tengah sisi luar', side: 'front', x: 78, y: 40 },
  { id: 9, label: 'Perut Kanan Bawah', side: 'front', x: 44, y: 55 },
  { id: 10, label: 'Perut Kiri Bawah', side: 'front', x: 56, y: 55 },
  { id: 11, label: 'Paha Kanan: 1/3 Tengah Sisi Luar', side: 'front', x: 40, y: 75 },
  { id: 12, label: 'Perut Tengah Atas (Hindari Area Dekat Pusar)', side: 'front', x: 50, y: 50 },
  { id: 13, label: 'Paha Kiri: 1/3 Tengah Sisi Luar', side: 'front', x: 60, y: 75 },
  { id: 14, label: 'Perut Tengah Bawah (Hindari Area Dekat Pusar)', side: 'front', x: 50, y: 60 },
  { id: 15, label: 'Lengan Atas Kanan: 1/3 Atas sisi belakang', side: 'back', x: 22, y: 30 },
  { id: 16, label: 'Lengan Atas Kiri: 1/3 Atas sisi belakang', side: 'back', x: 78, y: 30 },
  { id: 17, label: 'Bokong Kanan: Bagian sisi luar atas', side: 'back', x: 44, y: 65 },
  { id: 18, label: 'Bokong Kiri: Bagian sisi luar atas', side: 'back', x: 56, y: 65 },
  { id: 19, label: 'Lengan Atas Kanan: 1/3 Tengah sisi belakang', side: 'back', x: 22, y: 40 },
  { id: 20, label: 'Lengan Atas Kiri: 1/3 Tengah sisi belakang', side: 'back', x: 78, y: 40 }
];

/* ===========================================================================
   FR-08 / FR-09 — age bands, regions and point grids.

   Transcribed from the clinician-supplied illustrations. An injection site is
   a cell in a grid inside a region, and the grid size varies by age band —
   this replaces the pre-FR-08 model of 18/20 individually named points.

   ⚠ Perut (abdomen) and Bokong (buttocks) are marked on the body artwork but
   the client supplied NO point count and no zoom image for them. They are
   listed here as unavailable rather than guessed: an injection-point count is
   clinical data. Fill in `grids` and `zoomImage` when the client answers —
   nothing else has to change.
   ========================================================================= */

/** Band boundaries from the illustrations: <3, 3–<7, 7–18. */
export function getAgeBand(birthDate: string | null | undefined): AgeBand | null {
  if (!birthDate) {
    return null;
  }
  const born = new Date(birthDate);
  if (Number.isNaN(born.getTime())) {
    return null;
  }
  const today = new Date();
  let age = today.getFullYear() - born.getFullYear();
  const monthDelta = today.getMonth() - born.getMonth();
  if (monthDelta < 0 || (monthDelta === 0 && today.getDate() < born.getDate())) {
    age--;
  }
  if (age < 0) {
    return null;
  }
  if (age < 3) {
    return 'under-3';
  }
  if (age < 7) {
    return '3-to-7';
  }
  return 'over-7';
}

const AGE_BAND_LABELS: Record<string, string> = {
  'under-3': '< 3 tahun',
  '3-to-7': '3–<7 tahun',
  'over-7': '7–18 tahun',
  // Pre-FR-08 rows. Rendered as-is so history stays honest about which site
  // list the patient was actually shown.
  '2-10': '2–10 tahun (lama)',
  '11-plus': '≥11 tahun (lama)'
};

export function getAgeBandLabel(band: AgeGroup | null | undefined): string {
  if (!band) {
    return 'Tidak tercatat';
  }
  return AGE_BAND_LABELS[band] ?? 'Tidak dikenali';
}

export function isLegacyAgeGroup(band: AgeGroup | null | undefined): boolean {
  return band === '2-10' || band === '11-plus';
}

/** Body artwork per band and view. */
export const BODY_IMAGES: Record<AgeBand, Record<BodySide, string>> = {
  'under-3': {
    front: '/assets/images/depan-bayi-3-tahun.png',
    back: '/assets/images/belakang-bayi-3-tahun.png'
  },
  '3-to-7': {
    front: '/assets/images/depan-3-sampai-7-tahun.png',
    back: '/assets/images/belakang-3-sampai-7-tahun.png'
  },
  'over-7': {
    front: '/assets/images/depan-7-sampai-18-tahun.png',
    back: '/assets/images/belakang-7-sampai-18-tahun.png'
  }
};

export const injectionRegions: InjectionRegion[] = [
  { id: 'lengan-kanan', label: 'Lengan atas kanan', zoomImage: '/assets/images/lengan-kanan.png' },
  { id: 'lengan-kiri', label: 'Lengan atas kiri', zoomImage: '/assets/images/lengan-kiri.png' },
  { id: 'perut', label: 'Perut', zoomImage: null },
  { id: 'paha-kanan', label: 'Paha kanan', zoomImage: '/assets/images/paha.png' },
  // One thigh image serves both legs, mirrored.
  { id: 'paha-kiri', label: 'Paha kiri', zoomImage: '/assets/images/paha.png', mirrored: true },
  { id: 'bokong-kanan', label: 'Bokong kanan', zoomImage: null },
  { id: 'bokong-kiri', label: 'Bokong kiri', zoomImage: null }
];

/**
 * Where each region sits on each body image.
 *
 * Measured off the supplied artwork with a percentage grid, per band and per
 * view. They cannot be shared across bands: an infant's arms sit high and
 * close to the torso while a teenager's hang low and wide, so one set of
 * coordinates lands beside the body rather than on it.
 *
 * A region is offered for a band only if it has a placement here — which is
 * how "no abdomen under 3" is expressed, following the client's illustration
 * for that band, which marks no abdomen at all.
 */
const REGION_PLACEMENTS: RegionPlacement[] = [
  // ---- under 3 ----------------------------------------------------------
  { regionId: 'lengan-kanan', band: 'under-3', side: 'front', x: 19, y: 37, width: 13, height: 15 },
  { regionId: 'lengan-kiri', band: 'under-3', side: 'front', x: 68, y: 37, width: 13, height: 15 },
  { regionId: 'paha-kanan', band: 'under-3', side: 'front', x: 27, y: 64, width: 15, height: 14 },
  { regionId: 'paha-kiri', band: 'under-3', side: 'front', x: 56, y: 64, width: 15, height: 14 },
  { regionId: 'lengan-kanan', band: 'under-3', side: 'back', x: 21, y: 37, width: 12, height: 15 },
  { regionId: 'lengan-kiri', band: 'under-3', side: 'back', x: 67, y: 37, width: 12, height: 15 },
  { regionId: 'bokong-kanan', band: 'under-3', side: 'back', x: 32, y: 57, width: 16, height: 11 },
  { regionId: 'bokong-kiri', band: 'under-3', side: 'back', x: 52, y: 57, width: 16, height: 11 },

  // ---- 3 to under 7 -----------------------------------------------------
  { regionId: 'lengan-kanan', band: '3-to-7', side: 'front', x: 26, y: 32, width: 12, height: 16 },
  { regionId: 'lengan-kiri', band: '3-to-7', side: 'front', x: 62, y: 32, width: 12, height: 16 },
  { regionId: 'perut', band: '3-to-7', side: 'front', x: 35, y: 40, width: 30, height: 11 },
  { regionId: 'paha-kanan', band: '3-to-7', side: 'front', x: 31, y: 59, width: 14, height: 14 },
  { regionId: 'paha-kiri', band: '3-to-7', side: 'front', x: 55, y: 59, width: 14, height: 14 },
  { regionId: 'lengan-kanan', band: '3-to-7', side: 'back', x: 25, y: 33, width: 12, height: 15 },
  { regionId: 'lengan-kiri', band: '3-to-7', side: 'back', x: 63, y: 33, width: 12, height: 15 },
  { regionId: 'bokong-kanan', band: '3-to-7', side: 'back', x: 33, y: 57, width: 15, height: 11 },
  { regionId: 'bokong-kiri', band: '3-to-7', side: 'back', x: 52, y: 57, width: 15, height: 11 },

  // ---- 7 to 18 ----------------------------------------------------------
  { regionId: 'lengan-kanan', band: 'over-7', side: 'front', x: 27, y: 28, width: 10, height: 15 },
  { regionId: 'lengan-kiri', band: 'over-7', side: 'front', x: 63, y: 28, width: 10, height: 15 },
  { regionId: 'perut', band: 'over-7', side: 'front', x: 37, y: 42, width: 26, height: 9 },
  { regionId: 'paha-kanan', band: 'over-7', side: 'front', x: 33, y: 61, width: 13, height: 14 },
  { regionId: 'paha-kiri', band: 'over-7', side: 'front', x: 54, y: 61, width: 13, height: 14 },
  { regionId: 'lengan-kanan', band: 'over-7', side: 'back', x: 27, y: 30, width: 10, height: 14 },
  { regionId: 'lengan-kiri', band: 'over-7', side: 'back', x: 63, y: 30, width: 10, height: 14 },
  { regionId: 'bokong-kanan', band: 'over-7', side: 'back', x: 35, y: 50, width: 14, height: 11 },
  { regionId: 'bokong-kiri', band: 'over-7', side: 'back', x: 51, y: 50, width: 14, height: 11 }
];

/** Placements drawn on one body view, in a stable order. */
export function getPlacements(band: AgeBand | null, side: BodySide): RegionPlacement[] {
  if (!band) {
    return [];
  }
  return REGION_PLACEMENTS.filter(p => p.band === band && p.side === side);
}

/** Whether a region applies to a band at all (regardless of grid). */
export function regionAppliesTo(regionId: string, band: AgeBand): boolean {
  return REGION_PLACEMENTS.some(p => p.regionId === regionId && p.band === band);
}

/**
 * Point grids, per region per band, transcribed from the client's panels.
 *
 * A region with no entry is not selectable for that band. Perut and Bokong are
 * marked on the artwork but the client supplied NO point count for them, so
 * they are left empty rather than guessed — an injection-point count is
 * clinical data. Fill these in when the client answers; nothing else changes.
 */
const REGION_GRIDS: Record<string, Partial<Record<AgeBand, RegionGrid>>> = {
  'lengan-kanan': {
    'under-3': { rows: 2, cols: 2 },
    '3-to-7': { rows: 3, cols: 3 },
    'over-7': { rows: 4, cols: 4 }
  },
  'lengan-kiri': {
    'under-3': { rows: 2, cols: 2 },
    '3-to-7': { rows: 3, cols: 3 },
    'over-7': { rows: 4, cols: 4 }
  },
  'paha-kanan': {
    'under-3': { rows: 4, cols: 3 },
    '3-to-7': { rows: 5, cols: 5 },
    'over-7': { rows: 6, cols: 6 }
  },
  'paha-kiri': {
    'under-3': { rows: 4, cols: 3 },
    '3-to-7': { rows: 5, cols: 5 },
    'over-7': { rows: 6, cols: 6 }
  },
  // Awaiting the client: Perut (3-to-7, over-7) and Bokong (all bands).
  'perut': {},
  'bokong-kanan': {},
  'bokong-kiri': {}
};

export function getRegionGrid(regionId: string, band: AgeBand): RegionGrid | null {
  return REGION_GRIDS[regionId]?.[band] ?? null;
}

export function getRegion(regionId: string | null | undefined): InjectionRegion | null {
  if (!regionId) {
    return null;
  }
  return injectionRegions.find(region => region.id === regionId) ?? null;
}

/** Regions usable for a band — those with a supplied grid. */
export function getAvailableRegions(band: AgeBand | null): InjectionRegion[] {
  if (!band) {
    return [];
  }
  return injectionRegions.filter(
    region => regionAppliesTo(region.id, band) && getRegionGrid(region.id, band) !== null
  );
}

/** Regions drawn on the body but not yet selectable, so the UI can say why. */
export function getPendingRegions(band: AgeBand | null): InjectionRegion[] {
  if (!band) {
    return [];
  }
  return injectionRegions.filter(
    region => regionAppliesTo(region.id, band) && getRegionGrid(region.id, band) === null
  );
}

/** Total selectable points for a band — what the client's totals describe. */
export function getTotalPoints(band: AgeBand | null): number {
  if (!band) {
    return 0;
  }
  return getAvailableRegions(band).reduce((total, region) => {
    const grid = getRegionGrid(region.id, band);
    return total + (grid ? grid.rows * grid.cols : 0);
  }, 0);
}

/**
 * How many consecutive injections, counting back from the most recent, used
 * this region (FR-10).
 *
 * "Consecutive" is the point: three injections in the right thigh with a left
 * thigh in between is rotation working, not a problem worth interrupting a
 * child over.
 */
export function consecutiveUseOfRegion(
  regionId: string,
  recent: InjectionPoint[]
): number {
  let streak = 0;
  for (const point of recent) {
    if (point.regionId !== regionId) {
      break;
    }
    streak++;
  }
  return streak;
}

/**
 * How many times in a row the exact same point was used.
 *
 * Tracked separately from the region streak because repeatedly hitting one
 * spot is what causes lipodystrophy (FR-11), and it warrants a firmer nudge
 * than merely favouring one limb.
 */
export function consecutiveUseOfPoint(
  point: InjectionPoint,
  recent: InjectionPoint[]
): number {
  let streak = 0;
  for (const used of recent) {
    if (
      used.regionId !== point.regionId ||
      used.row !== point.row ||
      used.col !== point.col
    ) {
      break;
    }
    streak++;
  }
  return streak;
}

/** After this many consecutive uses of one area, warn (SoW Bagian 5). */
export const ROTATION_WARNING_THRESHOLD = 3;

/** After this many uses of the exact same point, warn more firmly. */
export const SAME_POINT_WARNING_THRESHOLD = 2;

/**
 * The rotation warning for a candidate point, or null when rotation looks
 * healthy. `recent` must be most-recent-first.
 */
export function getRotationWarning(
  candidate: InjectionPoint | null,
  recent: InjectionPoint[]
): string | null {
  if (!candidate) {
    return null;
  }

  const samePoint = consecutiveUseOfPoint(candidate, recent);
  if (samePoint >= SAME_POINT_WARNING_THRESHOLD) {
    return (
      `Titik ini sudah dipakai ${samePoint} kali berturut-turut. ` +
      'Sebaiknya pilih titik lain agar kulit tidak menebal.'
    );
  }

  const sameRegion = consecutiveUseOfRegion(candidate.regionId, recent);
  if (sameRegion >= ROTATION_WARNING_THRESHOLD) {
    // Wording fixed by the SoW.
    return (
      'Anda telah menggunakan area ini beberapa kali berturut-turut. ' +
      'Disarankan melakukan rotasi lokasi suntikan.'
    );
  }

  return null;
}

/** Human label for a chosen grid point. */
export function getPointLabel(
  regionId: string | null,
  row: number | null,
  col: number | null
): string {
  const region = getRegion(regionId);
  if (!region || row === null || col === null) {
    return 'Tidak tercatat';
  }
  return `${region.label} · baris ${row}, kolom ${col}`;
}

export function getSitesForAge(ageGroup: AgeGroup | null): InjectionSite[] {
  if (ageGroup === '2-10') {
    return kidsSites;
  }
  if (ageGroup === '11-plus') {
    return teenSites;
  }
  return [];
}

export function getSuggestedSiteCount(ageGroup: AgeGroup | null): number {
  if (ageGroup === '2-10') {
    return kidsSites.length;
  }
  if (ageGroup === '11-plus') {
    return teenSites.length;
  }
  return 0;
}

export interface MeasurementContext {
  id: string;
  label: string;
  group: MeasurementContextGroup;
}

/**
 * The ten glucose measurement contexts (FR-05, SoW Bagian 4).
 *
 * Deliberately age-independent — the previous four options were split by age
 * band, which FR-08's move to three bands would have had to touch. `group` is
 * presentation only; ten flat chips do not fit a phone screen.
 */
export const measurementContexts: MeasurementContext[] = [
  { id: 'pre-sarapan', label: 'Pre sarapan', group: 'pre' },
  { id: 'pre-makan-siang', label: 'Pre makan siang', group: 'pre' },
  { id: 'pre-makan-malam', label: 'Pre makan malam', group: 'pre' },
  { id: 'post-sarapan', label: 'Post sarapan', group: 'post' },
  { id: 'post-makan-siang', label: 'Post makan siang', group: 'post' },
  { id: 'post-makan-malam', label: 'Post makan malam', group: 'post' },
  { id: 'sebelum-tidur', label: 'Sebelum tidur', group: 'other' },
  { id: 'tengah-malam', label: 'Tengah malam', group: 'other' },
  { id: 'saat-hipoglikemia', label: 'Saat hipoglikemia', group: 'other' },
  { id: 'sewaktu', label: 'Sewaktu', group: 'other' }
];

export const measurementContextGroupLabels: Record<MeasurementContextGroup, string> = {
  'pre': 'Sebelum makan',
  'post': 'Sesudah makan',
  'other': 'Lainnya'
};

export function getMeasurementContextsByGroup(
  group: MeasurementContextGroup
): MeasurementContext[] {
  return measurementContexts.filter(context => context.group === group);
}

/** One selectable value of an FR-03 coded field. */
export interface CodedOption<T extends string> {
  id: T;
  label: string;
}

/**
 * Parent / guardian education (FR-03, SoW Bagian 2.3).
 *
 * The Indonesian school ladder, in ascending order — the order is meaningful,
 * so a report can treat the index as an ordinal without a lookup table.
 */
export const parentEducationOptions: CodedOption<ParentEducation>[] = [
  { id: 'tidak-sekolah', label: 'Tidak sekolah' },
  { id: 'sd', label: 'SD / sederajat' },
  { id: 'smp', label: 'SMP / sederajat' },
  { id: 'sma', label: 'SMA / SMK / sederajat' },
  { id: 'diploma', label: 'Diploma (D1–D3)' },
  { id: 's1', label: 'Sarjana (S1 / D4)' },
  { id: 'pascasarjana', label: 'Pascasarjana (S2 / S3)' }
];

/**
 * Monthly household income bands (FR-03).
 *
 * ⚠ The boundaries are a proposal pending client sign-off. They are rupiah
 * amounts rather than UMR multiples on purpose: UMR differs per province, so
 * "di bawah UMR" would mean different things at two hospitals in the same
 * cohort. Rewording a label here is free; changing an `id` is a data
 * migration, because the code is what migration 012 stores.
 *
 * 'tidak-menjawab' is last and sits apart from the ascending bands — it is a
 * refusal, not the top of the scale.
 */
export const familyIncomeOptions: CodedOption<FamilyIncomeBand>[] = [
  { id: 'lt-2jt', label: 'Kurang dari Rp 2 juta' },
  { id: '2jt-5jt', label: 'Rp 2 juta – Rp 5 juta' },
  { id: '5jt-10jt', label: 'Rp 5 juta – Rp 10 juta' },
  { id: 'gt-10jt', label: 'Lebih dari Rp 10 juta' },
  { id: 'tidak-menjawab', label: 'Tidak ingin menjawab' }
];

/** How care is paid for (FR-03). */
export const financingTypeOptions: CodedOption<FinancingType>[] = [
  { id: 'bpjs', label: 'BPJS' },
  { id: 'asuransi', label: 'Asuransi swasta' },
  { id: 'pribadi', label: 'Biaya pribadi' }
];

function labelFrom<T extends string>(
  options: CodedOption<T>[],
  id: string | null | undefined
): string | null {
  if (!id) {
    return null;
  }
  return options.find(option => option.id === id)?.label ?? id;
}

/**
 * Display label for a stored FR-03 code.
 *
 * Returns null for an unfilled field so a caller can choose its own placeholder,
 * and falls back to the raw code for a value this build does not know — a
 * profile edited by a newer build must not render as blank.
 */
export function getParentEducationLabel(id: string | null | undefined): string | null {
  return labelFrom(parentEducationOptions, id);
}

export function getFamilyIncomeLabel(id: string | null | undefined): string | null {
  return labelFrom(familyIncomeOptions, id);
}

export function getFinancingTypeLabel(id: string | null | undefined): string | null {
  return labelFrom(financingTypeOptions, id);
}

/**
 * Canonicalises an Indonesian mobile number to its leading-zero form.
 *
 * Accepts what parents actually type — `+62 812-3456-7890`, `62812 3456 7890`,
 * `0812.3456.7890` — and stores one shape, so two profiles with the same
 * number are comparable and the value round-trips through the input unchanged.
 * Returns null when there is nothing to store and the input itself when it is
 * not recognisably a number; validation is assertSocioEconomic()'s job, not
 * this function's.
 */
export function normalizeParentContact(raw: string | null | undefined): string | null {
  if (raw === null || raw === undefined) {
    return null;
  }
  const trimmed = raw.trim();
  if (!trimmed) {
    return null;
  }
  const compact = trimmed.replace(/[\s().-]/g, '');
  if (/^\+?62[0-9]+$/.test(compact)) {
    return '0' + compact.replace(/^\+?62/, '');
  }
  return compact;
}

/** Whether a normalised contact number is a plausible Indonesian number. */
export function isValidParentContact(value: string): boolean {
  return /^0[0-9]{8,13}$/.test(value);
}

/**
 * The pre-FR-04 injection types.
 *
 * FR-04 replaced these with the patient's own configured schedule slots, but
 * they are kept for two reasons: history rows written before FR-04 store these
 * ids and must still render, and a patient who has not configured a schedule
 * yet still needs something to pick from.
 */
export function getInsulinTypeOptions(): { id: string; label: string }[] {
  return [
    { id: 'basal-malam', label: 'Basal malam' },
    { id: 'basal-pagi', label: 'Basal pagi' },
    { id: 'pre-sarapan', label: 'Sebelum makan sarapan' },
    { id: 'pre-siang', label: 'Sebelum makan siang' },
    { id: 'pre-malam', label: 'Sebelum makan malam' },
    { id: 'koreksi', label: 'Ekstra / koreksi' }
  ];
}

/** Labels for the FR-04 schedule slots, which new rows store instead. */
const SLOT_LABELS: Record<string, string> = {
  'pagi': 'Pagi',
  'siang': 'Siang',
  'malam': 'Malam',
  'tambahan': 'Jadwal tambahan'
};

export function getSiteClass(
  site: InjectionSite,
  suggestedSiteId: number | null,
  selectedSiteId: number | null
): string {
  const classes = ['site-dot'];
  if (site.id === suggestedSiteId) {
    classes.push('suggested');
  }
  if (site.id === selectedSiteId) {
    classes.push('selected');
  }
  return classes.join(' ');
}

/**
 * The clinician-approved bands (improvement-1.md item 9), used when no
 * configured targets are available — a first load, an offline read, or a
 * caller that has no patient context. FR-06 seeds the database with exactly
 * these, so the configured and unconfigured paths agree until someone edits.
 */
export const DEFAULT_GLUCOSE_THRESHOLDS: GlucoseThresholds = {
  low: 70,
  normalMax: 150,
  warningMax: 250
};

export const DEFAULT_GLUCOSE_MESSAGES = {
  low: 'Glukosa darah rendah, makan/minum yang manis dan cek lagi.',
  normal: 'Glukosa darah aman, perhatikan dosis insulin sebelum makan.',
  warning: 'Perhatikan dosis insulin sesuai anjuran dokter.',
  high: 'Glukosa darah tinggi, perhatikan dosis insulin sesuai anjuran dokter.'
} as const;

/**
 * Whether a measurement context is evaluated against the post-prandial band.
 *
 * Only the three post-* contexts are. Bedtime, midnight, hypo checks and
 * random readings fall back to the pre-prandial (fasting-like) band, which is
 * the clinical convention and keeps FR-06 to two configurable ranges.
 */
export function isPostPrandialContext(contextId: string | null | undefined): boolean {
  if (!contextId) {
    return false;
  }
  const match = measurementContexts.find(context => context.id === contextId);
  return match?.group === 'post';
}

/** Picks the band set a reading should be judged against. */
export function thresholdsFor(
  targets: GlucoseTargets | null | undefined,
  contextId?: string | null
): GlucoseThresholds {
  if (!targets) {
    return DEFAULT_GLUCOSE_THRESHOLDS;
  }
  return isPostPrandialContext(contextId) ? targets.post : targets.pre;
}

/**
 * Single source of truth for the glucose zone.
 *
 * The thresholds were duplicated inline across CheckGlucose, Home and
 * Dashboard, which had drifted to three different sets. Everything routes
 * through here, so FR-06 only had to make *this* function configurable —
 * pass the band set from thresholdsFor(), or omit it for the seeded defaults.
 */
export function getGlucoseZone(
  value: number | null | undefined,
  thresholds: GlucoseThresholds = DEFAULT_GLUCOSE_THRESHOLDS
): GlucoseZone | null {
  if (value === null || value === undefined || value <= 0) {
    return null;
  }
  if (value < thresholds.low) {
    return 'low';
  }
  if (value <= thresholds.normalMax) {
    return 'normal';
  }
  if (value <= thresholds.warningMax) {
    return 'warning';
  }
  return 'high';
}

export function getGlucoseStatusText(
  zone: GlucoseZone | null,
  messages: GlucoseTargets['messages'] = DEFAULT_GLUCOSE_MESSAGES
): string | null {
  if (zone === null) {
    return null;
  }
  return messages[zone] ?? null;
}



export function getInsulinTypeLabel(id: string | null): string {
  if (!id) {
    return 'Tidak tercatat';
  }
  // Post-FR-04 rows store a schedule slot; older rows store one of the six
  // legacy types. Both have to render in history.
  if (SLOT_LABELS[id]) {
    return SLOT_LABELS[id];
  }
  const match = getInsulinTypeOptions().find(option => option.id === id);
  if (!match) {
    return 'Tidak dikenali';
  }
  return match.label;
}

export function getMeasurementContextLabel(id: string | null | undefined): string {
  if (!id) {
    return 'Tidak tercatat';
  }
  const match = measurementContexts.find(context => context.id === id);
  if (!match) {
    return 'Tidak dikenali';
  }
  return match.label;
}

export function getSiteLabelForHistory(ageGroup: AgeGroup, siteId: number | null): string {
  if (siteId === null) {
    return 'Cek Gula Darah Saja';
  }
  const sites = getSitesForAge(ageGroup);
  const match = sites.find(site => site.id === siteId);
  if (!match) {
    return `Lokasi ${siteId}`;
  }
  return `${match.id}: ${match.label}`;
}

export function getDateTimeValue(date: string, time: string): number {
  const iso = `${date}T${time || '00:00'}`;
  const value = Date.parse(iso);
  if (Number.isNaN(value)) {
    return 0;
  }
  return value;
}

export function formatDateTime(date: string, time: string): string {
  if (!date && !time) {
    return 'Tidak tercatat';
  }
  if (!date) {
    return time;
  }
  if (!time) {
    return date;
  }
  return `${date} ${time}`;
}
